<template lang="pug">
el-dialog.images-swiper(
  ref="dialog"
  visible
  close-on-press-escape
  close-on-click-modal
  @close="$emit('close')")
  .product-images-swiper

    .master(:style="{ transform: `rotate(${current.attachment_rotate}deg)`}")
      client-only
        image-zoom(
          :show-message="false"
          :regular="current.url"
          :zoom="current.url"
          :zoom-amount="2"
          @on-zoom="$amplitude.track(trackEvent, {...trackInfo, ...trackProps, position: currentIndex + 1})")

    .thumbnails.hidden-sm-and-down(v-if="images.length > 1")
      swiper.swiper(
        ref="thumbnails"
        :options="thumbnailsOptions"
        :auto-destroy="false")
        swiper-slide.image(
          v-for="i, k in images"
          :key="k"
          :class="{active: k === currentIndex}")
          .contain(
            v-image="i.thumbnail"
            :style="{transform: `rotate(${i.attachment_rotate}deg)`}"
            :title="i.title"
            @click="onSlideClick(i, k)")

      template(v-if="images.length > 1")
        .swiper-btn-next(slot="button-next" @click="onNextClick")
          i.bx.bx-chevron-right.bx-3.icon
        .swiper-btn-prev(slot="button-prev" @click="onPrevClick")
          i.bx.bx-chevron-left.bx-3.icon

</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'

export default {
  components: {
    Swiper,
    SwiperSlide,
    [process.client && 'ImageZoom']: () => import('vue-image-zoomer')
  },

  props: {
    images: {
      type: Array,
      default: () => []
    },
    initialIndex: {
      type: Number,
      default: 0
    },
    trackProps: {
      type: Object,
      default: () => ({
        zone: 'PRODUCT_DETAIL'
      })
    },
    trackEvent: {
      type: String,
      default: 'ZOOM_NUTRITION_LABEL_IMAGE'
    }
  },

  data () {
    return {
      currentIndex: this.initialIndex || 0
    }
  },

  computed: {
    trackInfo () {
      const res = /^(\d+)(?:-)?/ig.exec(this.$route.query.sku)
      const skuId = res ? +res[1] : null

      return {
        product_id: this.$route.params?.id,
        sku_id: skuId
      }
    },
    thumbnailsOptions () {
      return {
        spaceBetween: 12,
        slidesPerView: 5
      }
    },

    current () {
      return this.images[this.currentIndex]
    }
  },

  methods: {
    navigate (index) {
      this.currentIndex = index
      this.$refs.thumbnails?.$swiper?.slideTo(index, 600, false)
    },

    onSlideClick (image, index) {
      this.navigate(index)
    },

    onPrevClick () {
      if (this.currentIndex === 0) return false
      const index = this.currentIndex - 1
      this.navigate(index)
    },

    onNextClick () {
      if (this.currentIndex === this.images.length - 1) return false
      const index = this.currentIndex + 1
      this.navigate(index)
    }
  }
}
</script>

<style lang="scss" scoped>
.product-images-swiper {
  ::v-deep {
    .vh--outer {
      width: 100%;
      height: auto;
      .vh--holder {
        picture:first-child {
          width: 100%;
          height: auto;
          img {
            width: 100%;
            height: auto;
            aspect-ratio: 1;
            object-fit: contain;
          }
        }

        .vh--message {
          top: 15px;
          right: 15px;
          background: rgba($--color-text-secondary, .75);
          padding: 0;
          width: 32px;
          height: 32px;
          border-radius: 32px;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          justify-content: center;
          .vh--icon {
            margin-right: 0;
          }
        }
      }
      .vh--loading-o {
        background: transparent;
      }
    }
    .vh--image {
      max-width: initial;
      object-fit: contain;
      aspect-ratio: 1;
    }
  }
  .master {
    font-size: 0;
    position: relative;
    border-radius: $--radius;
    overflow: hidden;
    .image {
      .contain {
        background-color: white;
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        width: 100%;
        height: 0;
        padding-top: 100%;
      }
    }
    .indicator {
      position: absolute;
      z-index: 2;
      bottom: 1em;
      left: 1em;
      right: 1em;
      font-size: 13px;
      white-space: nowrap;
      .flex {
        justify-content: space-between
      }
      .variant,
      .counter {
        padding: .5em 1em;
        line-height: 1.2em;
        color: white;
        background: rgba($--color-text-secondary, .75);
        border-radius: 1000px;
      }
      .variant {
        max-width: 200px;
      }
    }
  }
  .thumbnails {
    margin-top: 15px;
    position: relative;
    .image {
      font-size: 0;
      padding: 1px;
      &.active {
        .contain {
          border-color: $--color-primary;
        }
      }
      .contain {
        cursor: pointer;
        background-color: white;
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        border-radius: $--radius;
        border: 1px solid #efeffb;
        width: 100%;
        height: 0;
        padding-top: 100%;
        position: relative;
        .promotion {
          position: absolute;
          top: 0;
          right: 0px;
          color: #fff;
          font-size: 10px;
          padding: 4px 5px;
          border-radius: $--radius;
          background: $--color-primary;
        }
      }
    }
    .swiper-container {
      width: calc(100% - 60px);
      margin: 0 auto;
    }
    .swiper-btn-prev,
    .swiper-btn-next {
      position: absolute;
      top: 35%;
      z-index: 10;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #DFDFEA;
      color: #988D98;
      padding: 5px;
      border-radius: 100%;
    }
    .swiper-btn-prev {
      left: 0px;
      right: auto;
    }
    .swiper-btn-next {
      right: 0px;
      left: auto;
    }
  }
}
</style>
